import * as types from './mutation-types'


const getStatusCode = (err) => err?.response?.status ?? err?.statusCode

const getLicenses = (response) => {
    const licenses = response?.data?.licenses
    if (!Array.isArray(licenses)) return []
    return licenses.filter(l => l?.is_active)
}

export const checkHasLicense = async ({ commit }, params = {}) => {
    commit(types.SET_LOADING, true)

    try {
        const response = await window.axios.get(
            'verify/license/validate',
            {
                params,
            }
        )

        const licenses = getLicenses(response)

        commit(types.SET_LICENSES, licenses)

        return response
    } catch (err) {
        const statusCode = getStatusCode(err)

        if (statusCode === 404) {
            commit(types.SET_LICENSES, [])
            return null
        }

        commit(types.SET_LICENSES, [])

        throw err
    } finally {
        commit(types.SET_LOADING, false)
    }
}

export const activateLicense = ({ commit }, payload) => {
    commit(types.SET_LOADING, true)
    return new Promise((resolve, reject) => {
        window.axios.post('active/license', payload)
            .then((response) => {
                commit(types.SET_LICENSE, response.data?.license || null)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    })
}

export const deactivateLicense = ({ commit }, payload) => {
    commit(types.SET_LOADING, true)
    return new Promise((resolve, reject) => {
        window.axios.post('deactivate/license/validate', payload)
            .then((response) => {
                commit(types.CLEAR_LICENSE)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
            .finally(() => {
                commit(types.SET_LOADING, false)
            })
    })
}

export const loadLicenseList = ({ commit }, payload) => {
    commit(types.SET_LIST_LOADING, true)

    return new Promise((resolve, reject) => {
        window.axios.get('get/licenses/list', { params: payload })
            .then((response) => {
                commit(types.SET_LICENSE_LIST, response.data?.licenses ?? response.data ?? [])
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
            .finally(() => {
                commit(types.SET_LIST_LOADING, false)
            })
    })
}


export const loadApiConfig = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/license/keys')
            .then((response) => {
                commit(types.SET_API_CONFIG, response.data?.data ?? response.data ?? null)
                resolve(response)
            })
            .catch((err) => {
                commit(types.SET_API_CONFIG, null)
                reject(err)
            })
    })
}

export const saveApiKeys = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/license/keys', payload)
            .then((response) => {
                commit(types.SET_API_CONFIG, payload)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const listenLicenseUpdated = ({ dispatch, rootGetters }) => {
    if (!window.Echo) return

    const userId = rootGetters['user/currentUser']?.id
    if (!userId) return

    window.Echo.private(`license.${userId}`)
        .listen('.license.updated', () => {
            dispatch('checkHasLicense')
        })
}
